<section class="accesibilidad-section">

  <div class="accesibilidad-container">

    <h2>ACCESIBILIDAD.</h2>

    <p>
      La página web de <strong>escarcega.tecnm.mx</strong> ha sido desarrollada utilizando tecnologías modernas
      como <strong>Angular</strong> para la estructuración del contenido dinámico y <strong>CSS3 con Bootstrap</strong>
      para el diseño responsivo, cumpliendo con las pautas de accesibilidad definidas por el W3C.
    </p>

    <p>
      El objetivo de estas directrices es garantizar el acceso a la información digital a todo tipo de usuarios,
      proporcionando una experiencia clara, accesible y adaptable a distintos dispositivos.
    </p>

    <p>
      Este sitio web ha sido validado mediante herramientas de evaluación de accesibilidad como TAW, y probado en
      diferentes entornos y dispositivos, alcanzando un nivel de cumplimiento conforme a estándares internacionales
      de accesibilidad web.
    </p>

    <p>
      Entre las medidas adoptadas para lograr estos objetivos se encuentran las siguientes:
    </p>

    <p>
      <strong>Diseño Responsivo:</strong> El sitio se adapta a distintos tamaños de pantalla gracias al uso de Bootstrap,
      permitiendo una correcta visualización en dispositivos móviles, tabletas y equipos de escritorio.
    </p>

    <p>
      <strong>Hojas de Estilo:</strong> Se emplea CSS3 para estructurar y presentar el contenido de manera visual,
      garantizando consistencia, claridad y compatibilidad entre navegadores modernos.
    </p>

    <p>
      <strong>Usabilidad y Navegación:</strong> La navegación del sitio está organizada de forma estructurada,
      intuitiva y coherente, facilitando el acceso a la información mediante menús claros y jerarquías bien definidas.
    </p>

    <p>
      <strong>Compatibilidad:</strong> El sistema ha sido desarrollado para funcionar correctamente en los principales
      navegadores actuales, asegurando estabilidad y rendimiento en diferentes plataformas.
    </p>

  </div>

<!-- elaborado por ArenasDev 2026 🌶️ -->

</section>